import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Backend } from "../../types/backend";

/**
 * 数据转换：query 接口数据 → DriveFile['previewInfo']
 */
export function transformQueryToPreviewInfo(raw) {
  var _transcodeTypeMap2Vid, _transcode_detail$0$m, _transcode_detail$0$m2;
  // 格式化各品类的 previewUrl
  var formatPreviewUrl = function formatPreviewUrl(url) {
    /**
     * @xcatliu 特殊逻辑：pdf 设置 client=drive
     * @jerrychuang 梳理这部分特殊逻辑背景：
     * 1. 2022年 9 月 Drive 接 PDF 需求
     * 2. PDF 前端开发认为全品类 previewUrl 中的 client=preview 是错误用法，PDF 不愿意一错再错，要改成 client=drive
     * 3. previewUrl 是 query 接口返回，drive 后台同学表示要给 pdf 做特定逻辑很恶心。
     * 4. 最后 drive 前端同学妥协，针对 pdf 把 client 参数改成 drive。
     * 5. client=drive，给到 PDF 表示是从 drive 来的预览场景，然后做一些特定化界面定制。
     */
    // TODO 这里私有化有特殊处理，在后面 CB 合流的时候，再来参考私有化改掉这里硬编码，换成配置下发。
    // eslint-disable-next-line @tencent/tdoc-standalone/no-use-uri-like-literal
    if (url.startsWith('https://docs.qq.com/pdf/')) {
      var newUrl = new URL(url);
      newUrl.searchParams.set('client', 'drive');
      return newUrl.toString();
    }
    return url;
  };
  var prefixProtocol = function prefixProtocol(url) {
    return url.replace(/(https?:\/\/)+|\/\//, 'https://');
  };
  var transcodeTypeMap2VideoUrlKey = (_transcodeTypeMap2Vid = {}, _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP3Original, 'origin'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4Original, 'origin'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4FLU, 'v480p'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4HD, 'v720p'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4FHD, 'v1080p'), _transcodeTypeMap2Vid);
  var previewInfo = {
    // 这里需要集中特殊处理一下后台返回的预览链接
    url: raw.preview_url ? formatPreviewUrl(prefixProtocol(raw.preview_url)) : '',
    // 预览 office 文档时 iframe 内嵌文档的 file_id，用于「转在线编辑」时调用生成副本接口
    documentMetadata: {
      // 自研预览的腾讯文档 fileId
      tdocsFileId: raw.file_id
    },
    videoMediaMetadata: {
      width: 0,
      height: 0,
      durationSeconds: 0,
      videoUrl: {}
    },
    audioMediaMetadata: {
      durationSeconds: 0
    },
    imageMediaMetadata: undefined
  };
  if (raw.transcode_detail.length === 0) return previewInfo;
  var transcode_detail = raw.transcode_detail;
  if ((_transcode_detail$0$m = transcode_detail[0].media) !== null && _transcode_detail$0$m !== void 0 && _transcode_detail$0$m.video) {
    previewInfo.videoMediaMetadata = {
      width: parseInt(transcode_detail[0].media.video.width, 10),
      height: parseInt(transcode_detail[0].media.video.height, 10),
      durationSeconds: parseInt(transcode_detail[0].media.video.length, 10),
      videoUrl: {}
    };
    var _iterator = _createForOfIteratorHelper(transcode_detail),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _step.value,
          streaming_url = _step$value.streaming_url,
          transcode_type = _step$value.transcode_type,
          status = _step$value.status;
        if (status === Backend.TranscodeStatus.Success) {
          var type = transcodeTypeMap2VideoUrlKey[transcode_type];
          previewInfo.videoMediaMetadata.videoUrl[type] = streaming_url;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  if ((_transcode_detail$0$m2 = transcode_detail[0].media) !== null && _transcode_detail$0$m2 !== void 0 && _transcode_detail$0$m2.audio) {
    previewInfo.audioMediaMetadata = {
      durationSeconds: parseInt(transcode_detail[0].media.audio.length, 10)
    };

    // FIXME(wenhuadu) 音频如果转了码的情况则使用转码url
    previewInfo.url = transcode_detail[0].streaming_url;
  }
  return previewInfo;
}
//# sourceMappingURL=transform-query-to-preview-info.js.map